import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import Alert from "../../components/Alert";
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../../helpers/user.js";
import axiosService from '../../helpers/axios';


  export default class GeneralParamsRegions extends Component{ 

    constructor(props){
      super(props);

      this.state={
          regions:[],
          modalTitle:"",
          regionname:"",
          regionid:0,
          description:"",
          isactive: true,
          country:"",

          RegionIdFilter:"",
          RegionNameFilter:"",
          DescriptionFilter:"",
          IsactiveFilter:"",
          regionsWithoutFilter:[],
          regionNames: [],
          regionExists: false,
          uniqueRegionIdsCountries:[],
          regionNameExistsCountries:false, 
      }
  }

  getCurrentFiscalYearAndMonth() {
    const currentDate = new Date();
    const fiscalYearStart = new Date(currentDate.getFullYear(), 6, 1); // July is month 6 (0-based index)
  
    let fiscalYear;
    let fiscalMonth;
  
    if (currentDate < fiscalYearStart) {
      // If the current date is before July 1st, subtract one year
      fiscalYear = currentDate.getFullYear() - 1;
      fiscalMonth = (currentDate.getMonth() + 12) % 12; // Get the month (0-11) and handle wrapping to previous year
    } else {
      // Otherwise, use the current year and month
      fiscalYear = currentDate.getFullYear();
      fiscalMonth = currentDate.getMonth();
    }
  
    return {
      fiscalYear: fiscalYear,
      fiscalMonth: fiscalMonth,
    };
  };



  FilterFn(){
    var RegionIdFilter=this.state.RegionIdFilter;
    var RegionNameFilter = this.state.RegionNameFilter;
    var DescriptionFilter = this.state.DescriptionFilter;
    var IsactiveFilter = this.state.IsactiveFilter;

    var filteredData=this.state.regionsWithoutFilter.filter(
        function(el){
            return el.regionid.toString().toLowerCase().includes(
                RegionIdFilter.toString().trim().toLowerCase()
            )&&
            el.regionname.toString().toLowerCase().includes(
                RegionNameFilter.toString().trim().toLowerCase()
            )&&
            el.isactive.toString().toLowerCase().includes(
                IsactiveFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({regions:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.regionsWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({regions:sortedData});

}

changeRegionIdFilter = (e)=>{
  this.state.RegionIdFilter=e.target.value;
  this.FilterFn();
}
changeRegionNameFilter = (e)=>{
  this.state.RegionNameFilter=e.target.value;
  this.FilterFn();
}

changeDescriptionFilter = (e)=>{
  this.state.DescriptionFilter=e.target.value;
  this.FilterFn();
}


changeIsActiveFilter = (e)=>{
  this.state.IsactiveFilter=e.target.value;
  this.FilterFn();
}




refreshList(){
  axiosService.get('/regions/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({regions:data,regionsWithoutFilter:data});
  });
}


fetchRegionNames() {
  axiosService.get('/regions/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const regionNames = data.map(item => item.regionname);
      this.setState({ regionNames: regionNames });
    })
    .catch(error => {
      console.error("Error fetching region names:", error);
    });
}

fetchRegionIdsCountries() {
  axiosService.get('/countries/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueRegionIdsCountries = [...new Set(data.map((item) => item.region.regionid))];
      this.setState({ uniqueRegionIdsCountries: uniqueRegionIdsCountries });
    })
    .catch((error) => {
      console.error('Error fetching countries data:', error);
    });
}

checkRegionExists = (event) => {
  const enteredRegion = event.target.value.toLowerCase(); // Convert to lowercase
  const { regionNames } = this.state;
  const regionExists = regionNames.some((region) => region.toLowerCase() === enteredRegion);
  this.setState({ regionExists });
};


checkRegionNameExistsCountries = (event) => {
  const enteredRegionName = event.target.value.toLowerCase(); // Convert to lowercase
  const { uniqueRegionIdsCountries} = this.state;

  const regionNameExistsCountries = uniqueRegionIdsCountries.some((productdescription) => productdescription.toLowerCase() === enteredRegionName);

  this.setState({ regionNameExistsCountries: regionNameExistsCountries });
};

componentDidMount(){
  this.refreshList();
  this.fetchRegionNames();
  this.fetchRegionIdsCountries();
}

changeRegionName =(e)=>{
  this.setState({regionname:e.target.value});
}

changeDescription =(e)=>{
  this.setState({description:e.target.value});
}
changeIsActive = (event) => {
  const isChecked = event.target.checked;
  this.setState({ isactive: isChecked });
};



addClick(){
  this.setState({
      modalTitle:"Add Region",
      regionid:0,
      regionname: "",
      isactive: true,
      regionExists: false,
      
  });
}
editClick(dep) {
  this.setState({
    modalTitle: "Edit Region",
    regionid: dep.regionid,
    regionname: dep.regionname,
    description: dep.description,
    isactive: dep.isactive,
    initialRegionname: dep.regionname,
    initialDescription: dep.description,
    initialIsactive: dep.isactive,
    regionExists: false,
  });
}

createClick() {
  const { regionname, description, isactive, regionNames } = this.state;

  if (!regionname) {
    alert('Region Name is required');
    return;
  }

  if (regionNames.some(name => name.toLowerCase() === regionname.toLowerCase())) {
    alert('Region already exists. Please provide a unique Region Name.');
    return;
  }
  


  axiosService.post('/regions/', {
    regionname: regionname,
    description: description,
    isactive: isactive
  })
    .then(result => {
      alert('Region created');
      this.refreshList();
      //window.location.reload();
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {
  const { regionname, description, isactive, initialRegionname, initialDescription, initialIsactive, regionNames } = this.state;

  // Check if any changes are detected
  if (
    regionname === initialRegionname &&
    description === initialDescription &&
    isactive === initialIsactive
  ) {
    alert('No changes detected');
    return;
  }

  if (
    regionNames.some((existingRegion) => existingRegion.toLowerCase() === regionname.toLowerCase() && regionname !== initialRegionname
    )
  ) {
    this.setState({ regionname : initialRegionname });
    return;
  }

  if (!regionname) {
    alert('Region Name is required');
    return;
  }


  axiosService.patch('/regions/' + id + '/', {
    regionid: this.state.regionid,
    regionname: this.state.regionname,
    description: this.state.description,
    isactive: this.state.isactive
  })
    .then(result => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}

deleteClick(id) {
    // Check if the id is in the array
    if (this.state.uniqueRegionIdsCountries.includes(id)) {
      alert('Cannot delete this Region as it is in the Countries Table !');
      return; // Exit the function without making the delete request
    }
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/regions/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        //window.location.reload();
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      regions,
      modalTitle,
      regionid,
      regionname,
      description,
      isactive,
      regionExists
  }=this.state;

  
  const currentFiscalYear = this.getCurrentFiscalYearAndMonth().fiscalYear;
  const currentFiscalMonth = this.getCurrentFiscalYearAndMonth().fiscalMonth;
  const selectedFiscalYear = parseInt(this.state.fyname, 10);
  const selectedFiscalMonth = parseInt(this.state.selectedMonth, 10);

  const isDisabledYear = currentFiscalYear > selectedFiscalYear;
  const isDisabledMonthFirshHalf = currentFiscalYear === selectedFiscalYear && (currentFiscalMonth > selectedFiscalMonth && currentFiscalMonth <=11 && currentFiscalMonth >=6);
  const isDisabledMonthSecondHalf = currentFiscalYear === selectedFiscalYear && (currentFiscalMonth > selectedFiscalMonth && currentFiscalMonth <=5 && currentFiscalMonth >=0);
  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}c
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Add Region
</button>
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeRegionIdFilter}
      placeholder="Filter"/>
      
      </div>
      RegionId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeRegionNameFilter}
      placeholder="Filter"/>

      </div>
      RegionName
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Description
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeIsActiveFilter}
      placeholder="Filter"/>

      </div>
      Is Active
  </th>
  
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {regions.map(dep=>
      <tr key={dep.regionid} className="row-hover">
          <td className="table-text">{dep.regionid}</td>
          <td className="table-text">{dep.regionname}</td>
          <td className="table-text">{dep.description}</td>
          <td className="table-text">{dep.isactive.toString()}</td>
          <td className="table-text">
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.regionid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>

          </td>
      </tr>
      )}
</tbody>
</table>
</div>
<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Region</span>
          <input
            type="text"
            className={`form-control ${regionExists ? "is-invalid" : ""}`}
            value={regionname}
            onChange={this.changeRegionName}
            onBlur={this.checkRegionExists} 
            style={{ fontSize: "12px" }} 
          />
          {regionExists && <div className="invalid-feedback" style={{ fontSize: "12px" }} >Region already exists.</div>}
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Description</span>
          <input type="text" className="form-control" value={description} onChange={this.changeDescription}
          style={{ fontSize: "12px" }} 
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Isactive</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={isactive}
            onChange={this.changeIsActive}
          />
        </div>
        
        

        {regionid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {regionid !== 0 ? (
          <button type="button" className="btn btn-primary float-start"  style={{ fontSize: "12px" }}  onClick={() => this.updateClick(regionid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>



</div>


  )
}


  }




